// context/UserContext.js
import { jwtDecode } from "jwt-decode";
import { createContext, useState, useEffect } from "react";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true); // <- add this

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("UserDetail")); // <- This is your token object
    const tokenNew=JSON.parse(storedToken)
    if (tokenNew?.Token) {
      const decodedUser = jwtDecode(tokenNew.Token); // <- Decode token again
      setUser(decodedUser);

      const parsedRoles =
        decodedUser?.[
          "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
        ] || [];
      setRoles(Array.isArray(parsedRoles) ? parsedRoles : [parsedRoles]); // normalize to array
    }
    setLoading(false);
  }, []);

  const login = (userData) => {
    const parsed =
      typeof userData === "string" ? JSON.parse(userData) : userData;
    localStorage.setItem("User", JSON.stringify(parsed));
    setUser(parsed);
    const parsedRoles =
      parsed?.[
        "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
      ] || [];
    setRoles(parsedRoles);
  };

  const logout = () => {
    localStorage.removeItem("User");
    setUser(null);
    setRoles([]);
  };

  return (
    <UserContext.Provider value={{ user, roles, login, logout, loading }}>
      {children}
    </UserContext.Provider>
  );
};
